import { render, staticRenderFns } from "./ConfirmForgotPass.vue?vue&type=template&id=2a27e534&"
import script from "./ConfirmForgotPass.vue?vue&type=script&lang=js&"
export * from "./ConfirmForgotPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports